import React, { Component, useState } from 'react'
import SRCards from '../../components/SRCards'
import {
    Button, Container, FormControl, InputLabel, Select, MenuItem,
    Dialog, DialogTitle, DialogContent, DialogActions, Snackbar, TextField, Grid,
    TableContainer, Table, TableHead, TableCell, TableBody, TableFooter, TableRow, Paper, Typography,
    Box,
} from '@material-ui/core'
import CommonServiceApi from '../../services/common-service'
import { isString } from 'lodash'
import { Alert } from '@material-ui/lab';
import TicketApi from '../../services/ticket.service'
import InvoiceApi from '../../services/invoice.service'
import EstimateApi from '../../services/estimate.service'
import CustomerApi from '../../services/customer.service'
import SelectCompany from '../../components/SelectCompany'
import { MOVE_MODULE_CONSTANTS } from '../../common/constants';

const { MODULES: {
    INDEPENDENT_EST_TO_DIFF_CUST,
    ESTIMATE_TO_DIFF_TICKET,
    INDEPENDENT_INV_TO_DIFF_CUST
} } = MOVE_MODULE_CONSTANTS;
const selectedValStyle = { color: '#1976D2' };

export default function MoveList() {
    const [module, setModule] = useState('');
    const [dialog, setDialog] = useState(false);
    const [snackBar, setSnackBar] = useState('');
    const [confirmMsg, setConfirmMsg] = useState('');
    const [pageResponse, setPageResponse] = useState('');
    const [errorDialog, setErrorDialog] = useState(false);
    const [estimates, setEstimates] = useState<string[]>([]);
    const [invoices, setInvoices] = useState<string[]>([]);
    const [customers, setCustomers] = useState<string[]>([]);
    const [tickets, setTickets] = useState<string[]>([]);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [estimateToBeMoved, setEstimateToBeMoved] = useState(null);
    const [invoiceToBeMoved, setInvoiceToBeMoved] = useState(null);
    const [ticketToBeMoved, setTicketToBeMoved] = useState(null);
    const [selectedTicket, setSelectedTicket] = useState(null);
    const [selectedEstimate, setSelectedEstimate] = useState(null);
    const [selectedService, setSelectedService] = useState(null);
    const [selectedBilling, setSelectedBilling] = useState(null);
    const [customerToBeMoved, setCustomerToBeMoved] = useState(null);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [serviceAddress, setServiceAddress] = useState<string[]>([]);
    const [isInvIndependent, setIsInvIndependent] = useState(false);
    const [isEstIndependent, setIsEstIndependent] = useState(false);
    const [serviceAddToBeMoved, setServiceAddToBeMoved] = useState(false);
    const [billingAddress, setBillingAddress] = useState<string[]>([]);
    const [billingAddToBeMoved, setBillingAddToBeMoved] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [billingServAddrId, setBillingServAddrId] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);

    const apiservices = new CommonServiceApi();
    const ticket_apiservices = new TicketApi();
    const invoice_apiservices = new InvoiceApi();
    const estimate_apiservices = new EstimateApi();
    const customer_apiservices = new CustomerApi();

    const handleFromChange = async (e: any) => {
        if (e.target.value === 1) {
            setModule('invoice-to-diff-ticket');

        }
        else if (e.target.value === 2) {
            setModule('independentInv-to-diff-customer');

        }
        else if (e.target.value === 3) {
            setModule('estimate-to-diff-ticket');

        }
        else if (e.target.value === 4) {
            setModule('independentEst-to-diff-customer');

        }
        else if (e.target.value === 5) {
            setErrorMsg("Service Address to different Billing is not implemented yet.");
            setErrorDialog(true);
            return;
            setModule('service-to-diff-billing');

        }
        setSelectedBilling(null);
        setSelectedCustomer(null);
        setSelectedEstimate(null);
        setSelectedInvoice(null);
        setSelectedService(null);
        setSelectedTicket(null);
        setBillingServAddrId(null);
        setEstimates([]);
        setInvoices([]);
        setCustomers([]);
        setTickets([]);
    }

    const confirmMove = (e: any) => {
        var companyId = localStorage.getItem('selectedCompanyId');
    
        if (!companyId) {
            setErrorMsg("Company ID is missing.");
            setErrorDialog(true);
            return;
        }
    
        if (!module) {
            setErrorMsg("Module type is missing.");
            setErrorDialog(true);
            return;
        }
    
        let res = "";
    
        switch (module) {
            case 'estimate-to-diff-ticket':
                if (!estimateToBeMoved) {
                    setErrorMsg("Estimate to be moved is missing.");
                } else if (!ticketToBeMoved) {
                    setErrorMsg("Target ticket is missing.");
                } else {
                    res = `This operation will move Estimate: "${selectedEstimate}" to Ticket: ${selectedTicket}. Are you sure?`;
                }
                break;
    
            case 'independentEst-to-diff-customer':
                if (!estimateToBeMoved) {
                    setErrorMsg("Estimate to be moved is missing.");
                } else if (!customerToBeMoved) {
                    setErrorMsg("Target customer is missing.");
                } else {
                    res = `This operation will move Estimate: "${selectedEstimate}" to Customer: ${selectedCustomer}. Are you sure?`;
                }
                break;
    
            case 'invoice-to-diff-ticket':
                if (!invoiceToBeMoved) {
                    setErrorMsg("Invoice to be moved is missing.");
                } else if (!ticketToBeMoved) {
                    setErrorMsg("Target ticket is missing.");
                } else {
                    res = `This operation will move Invoice: "${selectedInvoice}" to Ticket: ${selectedTicket}. Are you sure?`;
                }
                break;
    
            case 'independentInv-to-diff-customer':
                if (!invoiceToBeMoved) {
                    setErrorMsg("Invoice to be moved is missing.");
                } else if (!customerToBeMoved) {
                    setErrorMsg("Target customer is missing.");
                } else {
                    res = `This operation will move Invoice: "${selectedInvoice}" to Customer: ${selectedCustomer}. Are you sure?`;
                }
                break;
    
            // case 'service-to-diff-billing':
            //     if (!serviceAddToBeMoved) {
            //         setErrorMsg("Service Address to be moved is missing.");
            //     } else if (!customerToBeMoved) {
            //         setErrorMsg("Target customer is missing.");
            //     } else {
            //         res = `This operation will move Service Address: "${selectedService}" to Customer: ${selectedCustomer}. Are you sure?`;
            //     }
            //     break;
    
            default:
                setErrorMsg(`Invalid module type: ${module}.`);
                setErrorDialog(true);
                return;
        }
    
        if (res) {
            setDialog(true);
            setConfirmMsg(res);
        } else {
            setErrorDialog(true);
        }
    };
    

    const cancel = () => {
        setDialog(false);
        setSnackBar('info');
        setPageResponse(`Move Cancelled.`);
    }
    const resetValues = () => {
        setEstimateToBeMoved(null);
        setInvoiceToBeMoved(null);
        setTicketToBeMoved(null);
        setCustomerToBeMoved(null);
        setIsEstIndependent(false);
        setIsInvIndependent(false);

        setSelectedBilling(null);
        setSelectedCustomer(null);
        setSelectedEstimate(null);
        setSelectedInvoice(null);
        setSelectedService(null);
        setSelectedTicket(null);
        setInvoices([]);
        setEstimates([]);
        setTickets([]);
        setServiceAddress([]);
        setCustomers([]);
        setBillingServAddrId(null);
    };

    const move = async () => {
        let params = {};
        if (module) {
            if (module === 'estimate-to-diff-ticket') {
                params = {
                    estimateId: estimateToBeMoved, ticketId: ticketToBeMoved, module: module
                };
            }
            else if (module === 'independentEst-to-diff-customer') {
                params = {
                    estimateId: estimateToBeMoved, serviceAddressId: customerToBeMoved, independent: true, module: module
                };
            }
            else if (module === 'invoice-to-diff-ticket') {
                params = {
                    invoiceId: invoiceToBeMoved, ticketId: ticketToBeMoved, module: module
                };
            }
            else if (module === 'independentInv-to-diff-customer') {
                params = {
                    invoiceId: invoiceToBeMoved, serviceAddressId: customerToBeMoved, independent: true, module: module
                };
            }
            else if (module === 'service-to-diff-billing') {
                params = {
                    serviceAddressId: serviceAddToBeMoved, customerId: customerToBeMoved, module: module
                };
            }
            let response = await apiservices.move(params);
            if (response && ((response.id === estimateToBeMoved && (module === 'estimate-to-diff-ticket' || module === 'independentEst-to-diff-customer'))
                || (response.id === invoiceToBeMoved && (module === 'invoice-to-diff-ticket' || module === 'independentInv-to-diff-customer'))
                || module === 'service-to-diff-billing')) {
                setDialog(false);
                setSnackBar('success');
                setPageResponse("Moved Successfully.")
            }
            else {
                let msg;
                if (response && response.message && response.description) {
                    msg = `Move Failed: ${response.message} - ${response.description}`
                } else {
                    msg = `Move Failed.`
                }
                setDialog(false);
                setSnackBar('error');
                setPageResponse(msg);
            }
            resetValues();
            setIsProcessing(false);
        }
    }
    const onClose = () => {
        setErrorDialog(false)
    }
    const confirmBillingAddress = async (customerId: any, customerIdentifier: any) => {
        setSelectedBilling(customerIdentifier);
        setBillingAddToBeMoved(customerId);
        return
    }
    const onBillingAddSearch = async (e: any) => {
        if (e.key === 'Enter') {
            const response: any = await customer_apiservices.getBillingAdd(
                e.target.value
            );
            setBillingAddress(response);
        }
    }
    const confirmServiceAddress = async (customerId: any, customerIdentifier: any) => {
        setSelectedService(customerIdentifier);
        setServiceAddToBeMoved(customerId);
        return
    }
    const onServiceAddSearch = async (e: any) => {
        if (e.key === 'Enter') {
            const response: any = await customer_apiservices.getServiceAdd(
                e.target.value
            );
            setServiceAddress(response);
        }
    }
    const confirmCustomer = async (customerId: any, customerIdentifier: any) => {
        if (module === INDEPENDENT_EST_TO_DIFF_CUST || module === INDEPENDENT_INV_TO_DIFF_CUST) {
            if (customerId === billingServAddrId) {
                setErrorMsg("Can not move to same service address.");
                setErrorDialog(true);
                return;
            }
        }
        setSelectedCustomer(customerIdentifier);
        setCustomerToBeMoved(customerId); // service address id in case of independent invoice/estimate to different service address 
        return
    }
    const onCustomerSearch = async (e: any) => {
        if (e.key === 'Enter') {
            const response: any = await customer_apiservices.getCustomers(
                e.target.value
            );
            setCustomers(response);
        }
    }
    const confirmInvoice = async (invoice: any) => {
        if (module === INDEPENDENT_INV_TO_DIFF_CUST) {
            if (invoice?.serviceAddress?.id === customerToBeMoved) {
                setErrorMsg("Can not move invoice to same service address.");
                setErrorDialog(true);
                return;
            };
            setBillingServAddrId(invoice?.serviceAddress?.id);
        }
        setSelectedInvoice(invoice.invoiceNumber);
        setInvoiceToBeMoved(invoice.id);
        return
    }
    const onInvoiceSearch = async (e: any) => {
        if (e.key === 'Enter') {
            let response;
            if (module === 'invoice-to-diff-ticket') {
                setIsInvIndependent(false)
                response = await invoice_apiservices.getInvoices(
                    e.target.value, false
                );
            }
            if (module === 'independentInv-to-diff-customer') {
                setIsInvIndependent(true)
                response = await invoice_apiservices.getInvoices(
                    e.target.value, true
                );
            }
            setInvoices(response);
        }
    }
    const confirmTicket = async (ticketId: any, ticketNumber: any) => {
        setSelectedTicket(ticketNumber);
        setTicketToBeMoved(ticketId);
        return
    }
    const onTicketSearch = async (e: any) => {
        if (e.key === 'Enter') {
            const response = await ticket_apiservices.getTickets(
                e.target.value
            );
            setTickets(response);
        }
    }
    const confirmEstimate = async (estimate: any) => {
        if (module === INDEPENDENT_EST_TO_DIFF_CUST) {
            if (estimate?.serviceAddress?.id === customerToBeMoved) {
                setErrorMsg("Can not move estimate to same service address.");
                setErrorDialog(true);
                return;
            };
            setBillingServAddrId(estimate?.serviceAddress?.id);
        }
        setBillingServAddrId(estimate?.serviceAddress?.id);
        setSelectedEstimate(estimate.estimateNumber);
        setEstimateToBeMoved(estimate.id);
        return
    }
    const onEstimateSearch = async (e: any) => {
        if (e.key === 'Enter') {
            let response;
            if (module === 'estimate-to-diff-ticket') {
                setIsEstIndependent(false)
                response = await estimate_apiservices.getEstimates(
                    e.target.value, false
                );
            }
            if (module === 'independentEst-to-diff-customer') {
                setIsEstIndependent(true)
                response = await estimate_apiservices.getEstimates(
                    e.target.value, true
                );
            }
            setEstimates(response);
        }
    }

    return (
        <>
            <SRCards />
            <Container>
            <SelectCompany/>
            <br/><br/>
                <Button className='rediscache_body'
                    onClick={confirmMove}
                    style={{ margin: 10 }}
                    variant='outlined'> Move </Button>
                <Button onClick={resetValues} style={{ margin: 10 }} variant='outlined'>
                    RESET
                </Button>
                <br></br><br></br>
                <FormControl fullWidth className='rediscache_body'>
                    <InputLabel id="demo-simple-select-label">Modules</InputLabel>
                    <Select
                        onChange={handleFromChange}
                    >
                        <MenuItem value={1}>Invoice</MenuItem>
                        <MenuItem value={2}>Independent Invoice</MenuItem>
                        <MenuItem value={3}>Estimate</MenuItem>
                        <MenuItem value={4}>Independent Estimate</MenuItem>
                        {/* <MenuItem value={5}>Service Address to different Billing</MenuItem> */}
                    </Select>
                </FormControl>

                <br></br><br></br><br></br>

                {module === 'invoice-to-diff-ticket' &&
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <>
                                <Typography color="primary" noWrap>
                                    Select the Source Invoice
                                    <Box component="span" sx={selectedValStyle}>
                                        : {selectedInvoice}
                                    </Box>
                                </Typography>
  
                                <TextField
                                    style={{ padding: 20 }}
                                    variant="outlined"
                                    onKeyDown={(e) => onInvoiceSearch(e)}
                                    placeholder='Search Invoice..' />
                                <TableContainer
                                    component={Paper}
                                    style={{
                                        padding: 10, margin: 16
                                    }}
                                >
                                    <Table
                                        style={{
                                            minWidth: 700
                                        }}
                                        aria-label="customized table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Action</TableCell>
                                                <TableCell>Invoice</TableCell>
                                                <TableCell>Invoice Date</TableCell>
                                                <TableCell>Customer Name</TableCell>
                                                <TableCell>Customer Location</TableCell>
                                                <TableCell>Job Type</TableCell>
                                                <TableCell>Estimated Hours</TableCell>
                                                <TableCell>Sub Total</TableCell>
                                                <TableCell>Tax</TableCell>
                                                <TableCell>Total</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {invoices && invoices.length > 0 ?
                                            invoices.map((invoice: any) => {
                                                return (
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell>
                                                                <Button
                                                                    style={{ margin: 10 }}
                                                                    variant='outlined'
                                                                    onClick={() => confirmInvoice(invoice)}
                                                                >
                                                                    Select
                                                                </Button>
                                                            </TableCell>
                                                            <TableCell>
                                                                {invoice.invoiceNumber}
                                                            </TableCell>
                                                            <TableCell>
                                                                {invoice.invoiceDate}
                                                            </TableCell>
                                                            <TableCell>
                                                                {invoice.serviceAddress.displayName}
                                                            </TableCell>
                                                            <TableCell>
                                                                {invoice.serviceAddress.addressLine1},
                                                                {invoice.serviceAddress.city},
                                                                {invoice.serviceAddress.state},
                                                                {invoice.serviceAddress.zipcode}
                                                            </TableCell>
                                                            <TableCell>
                                                                {invoice.jobType}
                                                            </TableCell>
                                                            <TableCell>
                                                                {invoice.estimatedHours}
                                                            </TableCell>
                                                            <TableCell>
                                                                {invoice.subTotal}
                                                            </TableCell>
                                                            <TableCell>
                                                                {invoice.tax}
                                                            </TableCell>
                                                            <TableCell>
                                                                {invoice.total}
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                )
                                            }) : null}
                                        <TableFooter>
                                            <TableRow>

                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </>
                        </Grid>
                        <Grid item xs={6}>
                            <>
                                <Typography>
                                    Select the Target Ticket
                                    <Box component="span" sx={selectedValStyle}>
                                        : {selectedTicket}
                                    </Box>
                                </Typography>
                                <TextField
                                    style={{ padding: 20 }}
                                    variant="outlined"
                                    onKeyDown={(e) => onTicketSearch(e)}
                                    placeholder='Search Ticket..' />
                                <TableContainer
                                    component={Paper}
                                    style={{
                                        padding: 10, margin: 16
                                    }}
                                >
                                    <Table
                                        style={{
                                            minWidth: 700
                                        }}
                                        aria-label="customized table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Action</TableCell>
                                                <TableCell>Ticket Number</TableCell>
                                                <TableCell>Customer Name</TableCell>
                                                <TableCell>Address</TableCell>
                                                <TableCell>Job Type</TableCell>
                                                <TableCell>Description</TableCell>
                                                <TableCell>Start Time</TableCell>
                                                <TableCell>End Time</TableCell>
                                                <TableCell>Job Status</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {tickets && tickets.length ?
                                            tickets.map((ticket: any) => {
                                                return (
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell>
                                                                <Button
                                                                    style={{ margin: 10 }}
                                                                    variant='outlined'
                                                                    onClick={() => confirmTicket(ticket.id, ticket.ticketNumber)}
                                                                >
                                                                    Select
                                                                </Button>
                                                            </TableCell>
                                                            <TableCell>
                                                                {ticket.ticketNumber}
                                                            </TableCell>
                                                            <TableCell>
                                                                {ticket.serviceAddress && ticket.serviceAddress.displayName ?
                                                                    ticket.serviceAddress.displayName : ''}
                                                            </TableCell>
                                                            <TableCell>
                                                                {ticket.serviceAddress && ticket.serviceAddress.addressLine1 ?
                                                                    ticket.serviceAddress.addressLine1 : ''},
                                                                {ticket.serviceAddress && ticket.serviceAddress.city ?
                                                                    ticket.serviceAddress.city : ''},
                                                                {ticket.serviceAddress && ticket.serviceAddress.state ?
                                                                    ticket.serviceAddress.state : ''},
                                                                {ticket.serviceAddress && ticket.serviceAddress.zipcode ?
                                                                    ticket.serviceAddress.zipcode : ''}
                                                            </TableCell>
                                                            <TableCell>
                                                                {ticket.jobType}
                                                            </TableCell>
                                                            <TableCell>
                                                                {ticket.jobDescription}
                                                            </TableCell>
                                                            <TableCell>
                                                                {ticket.startTime}
                                                            </TableCell>
                                                            <TableCell>
                                                                {ticket.endTime}
                                                            </TableCell>
                                                            <TableCell>
                                                                {ticket.jobStatus}
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                )
                                            }) : null}
                                        <TableFooter>
                                            <TableRow>

                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </>
                        </Grid>
                    </Grid>
                }

                {module === 'independentInv-to-diff-customer' &&
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <>
                                <Typography>
                                    Select the Source Invoice
                                    <Box component="span" sx={selectedValStyle}>
                                        : {selectedInvoice}
                                    </Box>
                                </Typography>
                                <TextField
                                    style={{ padding: 20 }}
                                    variant="outlined"
                                    onKeyDown={(e) => onInvoiceSearch(e)}
                                    placeholder='Search Invoice..' />
                                <TableContainer
                                    component={Paper}
                                    style={{
                                        padding: 10, margin: 16
                                    }}
                                >
                                    <Table
                                        style={{
                                            minWidth: 700
                                        }}
                                        aria-label="customized table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Action</TableCell>
                                                <TableCell>Invoice</TableCell>
                                                <TableCell>Invoice Date</TableCell>
                                                <TableCell>Customer Name</TableCell>
                                                <TableCell>Customer Location</TableCell>
                                                <TableCell>Job Type</TableCell>
                                                <TableCell>Estimated Hours</TableCell>
                                                <TableCell>Sub Total</TableCell>
                                                <TableCell>Tax</TableCell>
                                                <TableCell>Total</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {invoices && invoices.length > 0 ?
                                            invoices.map((invoice: any) => {
                                                return (
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell>
                                                                <Button
                                                                    style={{ margin: 10 }}
                                                                    variant='outlined'
                                                                    onClick={() => confirmInvoice(invoice)}
                                                                >
                                                                    Select
                                                                </Button>
                                                            </TableCell>
                                                            <TableCell>
                                                                {invoice.invoiceNumber}
                                                            </TableCell>
                                                            <TableCell>
                                                                {invoice.invoiceDate}
                                                            </TableCell>
                                                            <TableCell>
                                                                {invoice?.serviceAddress?.customerId?.displayName ?? ""}
                                                            </TableCell>
                                                            <TableCell>
                                                                {invoice.serviceAddress.addressLine1},
                                                                {invoice.serviceAddress.city},
                                                                {invoice.serviceAddress.state},
                                                                {invoice.serviceAddress.zipcode}
                                                            </TableCell>
                                                            <TableCell>
                                                                {invoice.jobType}
                                                            </TableCell>
                                                            <TableCell>
                                                                {invoice.estimatedHours}
                                                            </TableCell>
                                                            <TableCell>
                                                                {invoice.subTotal}
                                                            </TableCell>
                                                            <TableCell>
                                                                {invoice.tax}
                                                            </TableCell>
                                                            <TableCell>
                                                                {invoice.total}
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                )
                                            }) : null}
                                        <TableFooter>
                                            <TableRow>

                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </>
                        </Grid>
                        <Grid item xs={6}>
                            <>
                                <Typography>
                                    Select the Target Customer 
                                    <Box component="span" sx={selectedValStyle}>
                                        : {selectedCustomer}
                                    </Box>
                                </Typography>
                                <TextField
                                    style={{ padding: 20 }}
                                    variant="outlined"
                                    onKeyDown={(e) => onCustomerSearch(e)}
                                    placeholder='Search Customer..' />
                                <TableContainer
                                    component={Paper}
                                    style={{
                                        padding: 10, margin: 16
                                    }}
                                >
                                    <Table
                                        style={{
                                            minWidth: 700
                                        }}
                                        aria-label="customized table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Action</TableCell>
                                                <TableCell>Customer Name</TableCell>
                                                <TableCell>Customer ID</TableCell>
                                                <TableCell>Customer Type</TableCell>
                                                <TableCell>Primary/Secondary</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {customers && customers.length > 0 ?
                                            customers.map((customer: any) => {
                                                return (
                                                    <TableBody>
                                                        {customer.serviceAddresses.length >= 1 ?
                                                            customer.serviceAddresses
                                                                .filter((serviceAddr: any) =>
                                                                    (!serviceAddr.isParent)
                                                                )
                                                                .map((serviceAddr: any) => {
                                                                    return (
                                                                        <TableRow>
                                                                            <TableCell>
                                                                                <Button
                                                                                    style={{ margin: 10 }}
                                                                                    variant='outlined'
                                                                                    onClick={() => confirmCustomer
                                                                                        (serviceAddr.id,
                                                                                            serviceAddr.customerIdentifier,

                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Select
                                                                                </Button>
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {serviceAddr.displayName}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {serviceAddr.customerIdentifier}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                Service
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                Secondary
                                                                            </TableCell>
                                                                        </TableRow>)
                                                                }) : null}
                                                    </TableBody>
                                                )
                                            }) : null}
                                        <TableFooter>
                                            <TableRow>

                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </>
                        </Grid>
                    </Grid>
                }
                {module === 'estimate-to-diff-ticket' &&
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <>
                                <Typography>
                                    Select the Source Estimate
                                    <Box component="span" sx={selectedValStyle}>
                                        : {selectedEstimate}
                                    </Box>
                                </Typography>
                                <TextField
                                    style={{ padding: 20 }}
                                    variant="outlined"
                                    onKeyDown={(e) => onEstimateSearch(e)}
                                    placeholder='Search Estimate..' />
                                <TableContainer
                                    component={Paper}
                                    style={{
                                        padding: 10, margin: 16
                                    }}
                                >
                                    <Table
                                        style={{
                                            minWidth: 700
                                        }}
                                        aria-label="customized table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Action</TableCell>
                                                <TableCell>Estimate</TableCell>
                                                <TableCell>Estimate Date</TableCell>
                                                <TableCell>Customer Name</TableCell>
                                                <TableCell>Customer Location</TableCell>
                                                <TableCell>Job Type</TableCell>
                                                <TableCell>Estimated Hours</TableCell>
                                                <TableCell>Sub Total</TableCell>
                                                <TableCell>Tax</TableCell>
                                                <TableCell>Total</TableCell>
                                                <TableCell>Estimate Status</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        {estimates && estimates.length > 0 ?
                                            estimates.map((estimate: any) => {
                                                return (
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell>
                                                                <Button
                                                                    style={{ margin: 10 }}
                                                                    variant='outlined'
                                                                    onClick={() => confirmEstimate(
                                                                        estimate
                                                                    )
                                                                    }
                                                                >
                                                                    Select
                                                                </Button>
                                                            </TableCell>
                                                            <TableCell>
                                                                {estimate.estimateNumber}
                                                            </TableCell>
                                                            <TableCell>
                                                                {estimate.estimateDate}
                                                            </TableCell>
                                                            <TableCell>
                                                                {
                                                                    estimate.serviceAddress ?
                                                                        estimate.serviceAddress.displayName ?
                                                                            estimate.serviceAddress.displayName :
                                                                            estimate.serviceAddress.customerId ?
                                                                                estimate.serviceAddress.customerId.name ?
                                                                                    estimate.serviceAddress.customerId.name :
                                                                                    estimate.serviceAddress.customerId.displayName ?
                                                                                        estimate.serviceAddress.customerId.displayName :
                                                                                        estimate.serviceAddress.customerId.firstname + ' ' + estimate.serviceAddress.customerId.lastname :
                                                                                '-' :
                                                                        estimate.billingAddress ? estimate.billingAddress.displayName ? estimate.billingAddress.displayName : '-' : '-'
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {estimate.serviceAddress.addressLine1},
                                                                {estimate.serviceAddress.city},
                                                                {estimate.serviceAddress.state},
                                                                {estimate.serviceAddress.zipcode}
                                                            </TableCell>
                                                            <TableCell>
                                                                {estimate.jobType}
                                                            </TableCell>
                                                            <TableCell>
                                                                {estimate.estimatedHours}
                                                            </TableCell>
                                                            <TableCell>
                                                                {estimate.subTotal}
                                                            </TableCell>
                                                            <TableCell>
                                                                {estimate.tax}
                                                            </TableCell>
                                                            <TableCell>
                                                                {estimate.total}
                                                            </TableCell>
                                                            <TableCell>
                                                                {estimate.estimateStatus}
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                )
                                            }) : null}
                                        <TableFooter>
                                            <TableRow>

                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </>
                        </Grid>
                        <Grid item xs={6}>
                            <>
                                <Typography>
                                    Select the Target Ticket
                                    <Box component="span" sx={selectedValStyle}>
                                        : {selectedTicket}
                                    </Box>
                                </Typography>
                                <TextField
                                    style={{ padding: 20 }}
                                    variant="outlined"
                                    onKeyDown={(e) => onTicketSearch(e)}
                                    placeholder='Search Ticket..' />
                                <TableContainer
                                    component={Paper}
                                    style={{
                                        padding: 10, margin: 16
                                    }}
                                >
                                    <Table
                                        style={{
                                            minWidth: 700
                                        }}
                                        aria-label="customized table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Action</TableCell>
                                                <TableCell>Ticket Number</TableCell>
                                                <TableCell>Customer Name</TableCell>
                                                <TableCell>Address</TableCell>
                                                <TableCell>Job Type</TableCell>
                                                <TableCell>Description</TableCell>
                                                <TableCell>Start Time</TableCell>
                                                <TableCell>End Time</TableCell>
                                                <TableCell>Job Status</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {tickets && tickets.length ?
                                            tickets.map((ticket: any) => {
                                                return (
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell>
                                                                <Button
                                                                    style={{ margin: 10 }}
                                                                    variant='outlined'
                                                                    onClick={() => confirmTicket(ticket.id, ticket.ticketNumber)}
                                                                >
                                                                    Select
                                                                </Button>
                                                            </TableCell>
                                                            <TableCell>
                                                                {ticket.ticketNumber}
                                                            </TableCell>
                                                            <TableCell>
                                                                {ticket.serviceAddress && ticket.serviceAddress.displayName ?
                                                                    ticket.serviceAddress.displayName : ''}
                                                            </TableCell>
                                                            <TableCell>
                                                                {ticket.serviceAddress && ticket.serviceAddress.addressLine1 ?
                                                                    ticket.serviceAddress.addressLine1 : ''},
                                                                {ticket.serviceAddress && ticket.serviceAddress.city ?
                                                                    ticket.serviceAddress.city : ''},
                                                                {ticket.serviceAddress && ticket.serviceAddress.state ?
                                                                    ticket.serviceAddress.state : ''},
                                                                {ticket.serviceAddress && ticket.serviceAddress.zipcode ?
                                                                    ticket.serviceAddress.zipcode : ''}
                                                            </TableCell>
                                                            <TableCell>
                                                                {ticket.jobType}
                                                            </TableCell>
                                                            <TableCell>
                                                                {ticket.jobDescription}
                                                            </TableCell>
                                                            <TableCell>
                                                                {ticket.startTime}
                                                            </TableCell>
                                                            <TableCell>
                                                                {ticket.endTime}
                                                            </TableCell>
                                                            <TableCell>
                                                                {ticket.jobStatus}
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                )
                                            }) : null}
                                        <TableFooter>
                                            <TableRow>

                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </>
                        </Grid>
                    </Grid>
                }
                {module === 'independentEst-to-diff-customer' &&
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <>
                                <Typography>
                                    Select the Source Estimate
                                    <Box component="span" sx={selectedValStyle}>
                                        : {selectedEstimate}
                                    </Box>
                                </Typography>
                                <TextField
                                    style={{ padding: 20 }}
                                    variant="outlined"
                                    onKeyDown={(e) => onEstimateSearch(e)}
                                    placeholder='Search Estimate..' />
                                <TableContainer
                                    component={Paper}
                                    style={{
                                        padding: 10, margin: 16
                                    }}
                                >
                                    <Table
                                        style={{
                                            minWidth: 700
                                        }}
                                        aria-label="customized table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Action</TableCell>
                                                <TableCell>Estimate</TableCell>
                                                <TableCell>Estimate Date</TableCell>
                                                <TableCell>Customer Name</TableCell>
                                                <TableCell>Customer Location</TableCell>
                                                <TableCell>Job Type</TableCell>
                                                <TableCell>Estimated Hours</TableCell>
                                                <TableCell>Sub Total</TableCell>
                                                <TableCell>Tax</TableCell>
                                                <TableCell>Total</TableCell>
                                                <TableCell>Estimate Status</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        {estimates && estimates.length > 0 ?
                                            estimates.map((estimate: any) => {
                                                return (
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell>
                                                                <Button
                                                                    style={{ margin: 10 }}
                                                                    variant='outlined'
                                                                    onClick={() => confirmEstimate(
                                                                        estimate
                                                                    )
                                                                    }
                                                                >
                                                                    Select
                                                                </Button>
                                                            </TableCell>
                                                            <TableCell>
                                                                {estimate.estimateNumber}
                                                            </TableCell>
                                                            <TableCell>
                                                                {estimate.estimateDate}
                                                            </TableCell>
                                                            <TableCell>
                                                                {
                                                                    estimate.serviceAddress ? estimate.serviceAddress.customerIdentifier? estimate.serviceAddress.customerIdentifier:
                                                                    estimate.serviceAddress.displayName?  estimate.serviceAddress.displayName :
                                                                        estimate.serviceAddress.customerId ?
                                                                            estimate.serviceAddress.customerId.name ?
                                                                                estimate.serviceAddress.customerId.name :
                                                                                estimate.serviceAddress.customerId.displayName ?
                                                                                    estimate.serviceAddress.customerId.displayName :
                                                                                    estimate.serviceAddress.customerId.firstname + ' ' + estimate.serviceAddress.customerId.lastname : '-': '-'
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {estimate.serviceAddress.addressLine1},
                                                                {estimate.serviceAddress.city},
                                                                {estimate.serviceAddress.state},
                                                                {estimate.serviceAddress.zipcode}
                                                            </TableCell>
                                                            <TableCell>
                                                                {estimate.jobType}
                                                            </TableCell>
                                                            <TableCell>
                                                                {estimate.estimatedHours}
                                                            </TableCell>
                                                            <TableCell>
                                                                {estimate.subTotal}
                                                            </TableCell>
                                                            <TableCell>
                                                                {estimate.tax}
                                                            </TableCell>
                                                            <TableCell>
                                                                {estimate.total}
                                                            </TableCell>
                                                            <TableCell>
                                                                {estimate.estimateStatus}
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                )
                                            }) : null}
                                        <TableFooter>
                                            <TableRow>

                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </>
                        </Grid>
                        <Grid item xs={6}>
                            <>
                                <Typography>
                                    Select the Target Customer
                                    <Box component="span" sx={selectedValStyle}>
                                        : {selectedCustomer}
                                    </Box>
                                </Typography>
                                <TextField
                                    style={{ padding: 20 }}
                                    variant="outlined"
                                    onKeyDown={(e) => onCustomerSearch(e)}
                                    placeholder='Search Customer..' />
                                <TableContainer
                                    component={Paper}
                                    style={{
                                        padding: 10, margin: 16
                                    }}
                                >
                                    <Table
                                        style={{
                                            minWidth: 700
                                        }}
                                        aria-label="customized table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Action</TableCell>
                                                <TableCell>Customer Name</TableCell>
                                                <TableCell>Customer ID</TableCell>
                                                <TableCell>Customer Type</TableCell>
                                                <TableCell>Primary/Secondary</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {customers && customers.length > 0 ?
                                            customers.map((customer: any) => {
                                                return (
                                                    <TableBody>
                                                        {customer.serviceAddresses.length >= 1 ?
                                                            customer.serviceAddresses
                                                                .filter((serviceAddr: any) =>
                                                                    (!serviceAddr.isParent)
                                                                )
                                                                .map((serviceAddr: any) => {
                                                                    return (
                                                                        <TableRow>
                                                                            <TableCell>
                                                                                <Button
                                                                                    style={{ margin: 10 }}
                                                                                    variant='outlined'
                                                                                    onClick={() => confirmCustomer
                                                                                        (serviceAddr.id,
                                                                                            serviceAddr.customerIdentifier
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Select
                                                                                </Button>
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {serviceAddr.displayName}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {serviceAddr.customerIdentifier}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                Service
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                Secondary
                                                                            </TableCell>
                                                                        </TableRow>)
                                                                }) : null}
                                                    </TableBody>
                                                )
                                            }) : null}
                                        <TableFooter>
                                            <TableRow>

                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </>
                        </Grid>
                    </Grid>
                }
                {module === 'service-to-diff-billing' &&
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <>
                                <Typography>
                                    Select the Source Service Address
                                    <Box component="span" sx={selectedValStyle}>
                                        : {selectedService}
                                    </Box>
                                </Typography>
                                <TextField
                                    style={{ padding: 20 }}
                                    variant="outlined"
                                    onKeyDown={(e) => onServiceAddSearch(e)}
                                    placeholder='Search Service Address..' />
                                <TableContainer
                                    component={Paper}
                                    style={{
                                        padding: 10, margin: 16
                                    }}
                                >
                                    <Table
                                        style={{
                                            minWidth: 700
                                        }}
                                        aria-label="customized table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Action</TableCell>
                                                <TableCell>Customer Name</TableCell>
                                                <TableCell>Service Address</TableCell>
                                                <TableCell>Customer ID</TableCell>
                                                <TableCell>Created At</TableCell>
                                                <TableCell>Updated At</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        {serviceAddress && serviceAddress.length > 0 ?
                                            serviceAddress.map((serviceAdd: any) => {
                                                return (
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell>
                                                                <Button
                                                                    style={{ margin: 10 }}
                                                                    variant='outlined'
                                                                    onClick={() => confirmServiceAddress(
                                                                        serviceAdd.id,
                                                                        serviceAdd.displayName
                                                                    )
                                                                    }
                                                                >
                                                                    Select
                                                                </Button>
                                                            </TableCell>
                                                            <TableCell>
                                                                {serviceAdd.displayName}
                                                            </TableCell>
                                                            <TableCell>
                                                                {
                                                                    serviceAdd.serviceAddress ?
                                                                        serviceAdd.serviceAddress : '-'
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {serviceAdd.customerIdentifier},
                                                            </TableCell>
                                                            <TableCell>
                                                                {serviceAdd.createdAt}
                                                            </TableCell>
                                                            <TableCell>
                                                                {serviceAdd.updatedAt}
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                )
                                            }) : null}
                                        <TableFooter>
                                            <TableRow>

                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </>
                        </Grid>
                        <Grid item xs={6}>
                            <>
                                <Typography>
                                    Select the Target Customer
                                    <Box component="span" sx={selectedValStyle}>
                                        : {selectedCustomer}
                                    </Box>
                                </Typography>
                                <TextField
                                    style={{ padding: 20 }}
                                    variant="outlined"
                                    onKeyDown={(e) => onCustomerSearch(e)}
                                    placeholder='Search Customer..' />
                                <TableContainer
                                    component={Paper}
                                    style={{
                                        padding: 10, margin: 16
                                    }}
                                >
                                    <Table
                                        style={{
                                            minWidth: 700
                                        }}
                                        aria-label="customized table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Action</TableCell>
                                                <TableCell>Customer Name</TableCell>
                                                <TableCell>Customer ID</TableCell>
                                                <TableCell>Customer Type</TableCell>
                                                <TableCell>Primary/Secondary</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {customers && customers.length > 0 ?
                                            customers.map((customer: any) => {
                                                return (
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell>
                                                                <Button
                                                                    style={{ margin: 10 }}
                                                                    variant='outlined'
                                                                    onClick={() => confirmCustomer(
                                                                        customer.id,
                                                                        customer.customerIdentifier
                                                                    )
                                                                    }
                                                                >
                                                                    Select
                                                                </Button>
                                                            </TableCell>
                                                            <TableCell>
                                                                {customer.displayName}
                                                            </TableCell>
                                                            <TableCell>
                                                                {customer.customerIdentifier}
                                                            </TableCell>
                                                            <TableCell>
                                                                Root Customer
                                                            </TableCell>
                                                            <TableCell>
                                                                Primary
                                                            </TableCell>
                                                        </TableRow>
                                                        {customer.serviceAddresses.length >= 1 ?
                                                            customer.serviceAddresses
                                                                .filter((serviceAddr: any) =>
                                                                    (!serviceAddr.isParent)
                                                                )
                                                                .map((serviceAddr: any) => {
                                                                    return (
                                                                        <TableRow>
                                                                            <TableCell>
                                                                                <Button
                                                                                    style={{ margin: 10 }}
                                                                                    variant='outlined'
                                                                                    onClick={() => confirmCustomer
                                                                                        (serviceAddr.id,
                                                                                            serviceAddr.customerIdentifier
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Select
                                                                                </Button>
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {serviceAddr.displayName}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {serviceAddr.customerIdentifier}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                Service
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                Secondary
                                                                            </TableCell>
                                                                        </TableRow>)
                                                                }) : null}
                                                    </TableBody>
                                                )
                                            }) : null}
                                        <TableFooter>
                                            <TableRow>

                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </>
                        </Grid>
                    </Grid>
                }

                <Dialog
                    open={dialog}
                    onClose={() => {
                        setDialog(false)
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">
                        {'Confirmation!'}
                    </DialogTitle>
                    <DialogContent>
                        {confirmMsg}
                        {!isProcessing && (module === INDEPENDENT_EST_TO_DIFF_CUST || module === ESTIMATE_TO_DIFF_TICKET) ? <div style={{ marginTop: 10 }}>
                            <b style={{ color: 'red' }}>Caution: </b>
                            If the target estimate is one of the estimates in the GBB package, all the estimates in the GBB package will be moved.
                        </div> : null}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={
                                () => {
                                    setIsProcessing(true);
                                    setConfirmMsg('Processing...')
                                    move()
                                }
                            }
                        >
                            Confirm
                        </Button>
                        <Button
                            onClick={
                                () => cancel()
                            }
                            autoFocus
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={errorDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogContent>
                        {errorMsg}
                    </DialogContent>
                    <Button onClick={onClose}>Ok</Button>
                </Dialog>
                <Snackbar
                    open={snackBar === '' ? false : true}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    autoHideDuration={6000}
                    onClose={() => {
                        setSnackBar('')
                    }}
                >
                    <Alert
                        severity={snackBar === 'error' ? 'error' : 'success'}
                        onClose={() => {
                            setSnackBar('')
                        }
                        }>
                        {pageResponse}
                    </Alert>
                </Snackbar>
            </Container>
        </>
    )
}